// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ecmascript-language-types-undefined-type
export function isUndefined(x: any): boolean {
  return x === undefined;
}



/** WEBPACK FOOTER **
 ** ./src/helper/is-undefined.ts
 **/